import StepsIndicator from '../steps-indicator'
import { Input } from '../ui'
import { PasswordInput } from '../ui/password-input'
import { Alert, AlertDescription } from '../ui/alert'
import { Button } from '../ui/button'
import { Card } from '../ui/card'
import { Label } from '@/components/ui/label';

interface SetupPasswordProps {
  setPassword: (password: string) => void
  setConfirmPassword: (confirmPassword: string) => void
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void
  isLoading?: boolean
  formError?: string
}

export function SetupPassword({
  setPassword,
  setConfirmPassword,
  handleSubmit,
  isLoading,
  formError,
}: SetupPasswordProps) {
  return (
    <div className="w-full min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="w-full max-w-5xl bg-slate-900 rounded-2xl border border-slate-700 shadow-2xl overflow-hidden">
        <div className="flex min-h-[500px]">
          {/* Left Panel - Marketing Content */}
          <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden rounded-l-2xl">
            <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url(/fanfairpartnerlogin.jpg)` }}/>
            {/* Header */}
            <div className="absolute top-6 left-6 right-6 flex items-center justify-between z-10">
              <div className="flex items-center">
                <img src="/fanfairreversed.png" alt="FanFair" className="h-8"/>
              </div>
            </div>
            {/* Content */}
            <div className="relative z-10 w-full flex items-center justify-center p-12">
              <div className="text-center text-white max-w-md">
                <h1 className="text-4xl font-bold mb-4 text-white">
                  Setup Password
                </h1>
                <p className="text-lg opacity-90 mb-8 text-white">
                </p>
                {/* Slide indicators */}
                <div className="flex justify-center space-x-2">
                  <div className="w-8 h-1 bg-white rounded-full"></div>
                  <div className="w-1 h-1 bg-white/40 rounded-full"></div>
                  <div className="w-1 h-1 bg-white/40 rounded-full"></div>
                </div>
              </div>
            </div>
          </div>
          {/* Right Panel - Login Form */}
          <div className="w-full lg:w-1/2 bg-slate-800 flex items-center justify-center p-6 lg:p-12">
            <div className="w-full max-w-sm space-y-8">
              {/* Mobile Header */}
              <div className="lg:hidden text-center">
                <img src="/fanfairreversed.png" alt="FanFair" className="h-8 mx-auto"/>
              </div>
              <div className="space-y-2">
                <h1 className="text-2xl font-medium text-white">Just do these 3 quick steps to activate your account.</h1>
              </div>
              <div>
                <form onSubmit={handleSubmit}>
                  <div className="flex flex-col w-full gap-8">
                    <StepsIndicator currentStep={1} />
                    {formError && (
                      <Alert variant="destructive" className="mt-6">
                        <AlertDescription>{formError}</AlertDescription>
                      </Alert>
                    )}
                    <div className="flex flex-col gap-4 mt-3">
                      <div className="flex flex-col gap-2">
                        <Label className="text-sm font-medium text-white">Password *</Label>
                        <PasswordInput
                          className="bg-slate-700 border-slate-600 text-white placeholder-slate-400 focus:border-primary focus:ring-primary/20"
                          placeholder="Enter Your Password"
                          onChange={(e) => setPassword(e.target.value)}
                          required
                          disabled={isLoading}
                          data-testid="password-input"
                        />
                        <p className="text-gray-300 text-xs">Must contain at least 12 characters</p>
                      </div>
                      <div className="flex flex-col gap-2">
                        <Label className="text-sm font-medium text-white">Confirm Password *</Label>
                        <PasswordInput
                          className="bg-slate-700 border-slate-600 text-white placeholder-slate-400 focus:border-primary focus:ring-primary/20"
                          placeholder="Re-enter Your Password"
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                          disabled={isLoading}
                          data-testid="confirm-password-input"
                        />
                        {/*<p className="text-gray-300 text-xs">Both passwords must match</p>*/}
                      </div>
                    </div>
                    <Button type="submit" disabled={isLoading} className="w-full bg-primary hover:bg-primary/90 text-primary-foreground">
                      {isLoading ? 'Setting Password...' : 'Set Password'}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
